import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupContraception = () => {
  const { t } = useTranslation();

  return {
    clinicName: Yup.string().required(
      t("validation.required", {
        clinicName: t("page.provider_name"),
      })
    ),
    reportingFrom: Yup.string().required(
        t("validation.required", {
          reportingFrom: t("page.reporting_from"),
        })
      ),
    reportingTo: Yup.string().required(
        t("validation.required", {
        reportingTo: t("page.reporting_to"),
        })
    ),
    submittedDate: Yup.string().required(
        t("validation.required", {
        submittedDate: t("page.submitted_date"),
        })
    ),
    submittedBy: Yup.string().required(
      t("validation.required", {
        submittedBy: t("page.submitted_by"),
      })
    ),
    contraceptionClients: Yup.array()
      .required(
        t("validation.required", {
          contraceptionClients: t("page.client"),
        })
      )
      .min(1),
  };
};
